if (!customElements.get('gms-fondue')) {
  customElements.define('gms-fondue', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      this.dialog = this.querySelector('dialog');
      this.button = this.querySelector('[data-fondue-add]');
      this.buyButton = this.querySelector('[data-buy-now]');
      this.sticky = this.querySelector('[data-fondue-sticky]');
      this.stickyButton = this.querySelector('[data-fondue-sticky-add]');
      this.slots = [...this.querySelectorAll('[data-fondue-select]')];
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.form.querySelectorAll('[name="pack"]').forEach(input => input.disabled = false);
      this.form.addEventListener('change', event => this.update(event.target.matches('[data-fondue-select]') ? event.target : null), opts);
      this.form.addEventListener('submit', event => this.add(event), opts);
      this.querySelectorAll('[data-fondue-thumb]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.fondueThumb), opts));
      this.querySelectorAll('[data-fondue-photo]').forEach(button => button.addEventListener('click', () => {
        const original = button.querySelector('img');
        const large = this.querySelector('[data-fondue-large]');
        large.src = original.src;
        large.srcset = original.srcset;
        large.sizes = '90vw';
        large.alt = original.alt;
        this.dialog.showModal();
      }, opts));
      this.querySelectorAll('[data-fondue-step]').forEach(button => button.addEventListener('click', () => this.stepImage(Number(button.dataset.fondueStep)), opts));
      [this.querySelector('.gms-fondue-stage'), this.dialog].forEach(gallery => gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.stepImage(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, opts));
      const initialPhoto = this.querySelector('[data-fondue-photo]:not([hidden])');
      if (initialPhoto) this.showImage(initialPhoto.dataset.fonduePhoto);
      this.querySelector('[data-fondue-close]').addEventListener('click', () => this.dialog.close(), opts);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, opts);
      const requested = new URLSearchParams(location.search).get('pack');
      const pack = requested === 'pair' ? '2' : requested;
      if (['1','2','3','4'].includes(pack)) this.form.querySelector(`[name="pack"][value="${pack}"]`).checked = true;
      this.update(null);
      this.observer = new IntersectionObserver(entries => {
        this.sticky.hidden = entries[0].isIntersecting;
      }, { threshold: 0 });
      this.observer.observe(this.button);
      window.addEventListener('pageshow', async event => {
        this.busy = false; this.form.removeAttribute('aria-busy');
        if (event.persisted) {
          try {
            const response = await fetch(`${this.dataset.cart}.js`, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Cart unavailable');
            const cart = await response.json();
            this.dataset.existing = cart.items.filter(item => String(item.product_id) === this.dataset.product).reduce((sum,item) => sum + item.quantity,0);
          } catch { this.dataset.existing = '0'; }
        }
        this.update(null);
      }, opts);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
    saving(count) { return this.dataset.currency === 'USD' ? (count >= 4 ? 3997 : count === 3 ? 2498 : count === 2 ? 1499 : 0) : 0; }
    stepImage(direction) {
      const photos = [...this.querySelectorAll('[data-fondue-photo]')];
      const current = photos.findIndex(photo => !photo.hidden);
      const next = photos[(current + direction + photos.length) % photos.length];
      if (next) this.showImage(next.dataset.fonduePhoto);
    }
    showImage(id) {
      this.querySelectorAll('[data-fondue-photo]').forEach(photo => {
        photo.hidden = photo.dataset.fonduePhoto !== String(id);
        if (!photo.hidden) photo.querySelector('img').loading = 'eager';
      });
      this.querySelectorAll('[data-fondue-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fondueThumb === String(id))));
      const photos = [...this.querySelectorAll('[data-fondue-photo]')];
      const index = photos.findIndex(photo => !photo.hidden);
      const counter = this.querySelector('[data-fondue-counter]');
      if (counter) counter.textContent = `${index + 1} / ${photos.length}`;
      if (this.dialog.open && photos[index]) {
        const original = photos[index].querySelector('img');
        const large = this.querySelector('[data-fondue-large]');
        large.src = original.src; large.srcset = original.srcset; large.alt = original.alt;
      }
    }
    update(changedSelect) {
      this.quantity = Number(this.form.querySelector('[name="pack"]:checked').value);
      const price = Number(this.dataset.price);
      const saving = this.saving(this.quantity);
      const total = price * this.quantity - saving;
      this.slots.forEach((select, index) => {
        select.disabled = index >= this.quantity;
        const row = select.closest('[data-fondue-slot]');
        row.hidden = select.disabled;
        row.querySelector('[data-slot-image]').src = select.selectedOptions[0].dataset.thumb;
      });
      this.querySelectorAll('[data-fondue-total],[data-fondue-sticky-price]').forEach(el => el.textContent = this.money.format(total / 100));
      const selectedCard = this.form.querySelector('[name="pack"]:checked').closest('label');
      const savings = this.querySelector('[data-fondue-total-saving]');
      savings.hidden = saving === 0;
      savings.textContent = selectedCard.querySelector('.gms-fondue-saving').textContent;
      const count = Number(this.dataset.existing) || 0;
      const cartNote = this.querySelector('[data-fondue-cart-note]');
      cartNote.hidden = count === 0;
      cartNote.textContent = this.dataset.cartTemplate.replace('__COUNT__',count).replace('__TOTAL_COUNT__',count + this.quantity).replace('__TOTAL__',this.money.format((price * (count + this.quantity) - this.saving(count + this.quantity)) / 100));
      const available = this.slots.slice(0,this.quantity).every(select => select.selectedOptions[0].dataset.available === 'true');
      this.button.disabled = !available || Boolean(this.busy);
      this.stickyButton.disabled = this.button.disabled;
      this.buyButton.disabled = this.button.disabled;
      this.buyButton.textContent = this.busy ? this.dataset.adding : !available ? this.button.dataset.unavailable : this.buyButton.dataset.buyLabel;
      this.button.textContent = this.busy ? this.dataset.adding : !available ? this.button.dataset.unavailable : this.quantity === 1 ? this.button.dataset.label : this.dataset.addCount.replace('__COUNT__',this.quantity);
      this.stickyButton.textContent = this.busy ? this.dataset.adding : this.button.dataset.label;
      const url = new URL(location.href);
      url.searchParams.set('variant', this.slots[0].value);
      if (this.quantity > 1) url.searchParams.set('pack', String(this.quantity)); else url.searchParams.delete('pack');
      history.replaceState({}, '', url);
      if (changedSelect) this.showImage(changedSelect.selectedOptions[0].dataset.image);
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const error = this.querySelector('[data-fondue-error]');
      const cartLink = this.querySelector('[data-fondue-error-cart]');
      error.hidden = true; cartLink.hidden = true;
      const checkout = event.submitter?.hasAttribute('data-buy-now');
      const destination = checkout ? event.submitter.value : this.dataset.cart;
      const active = this.slots.slice(0,this.quantity);
      if (active.some(select => select.selectedOptions[0].dataset.available !== 'true')) {
        error.textContent = this.dataset.chooseError; error.hidden = false; return;
      }
      const grouped = new Map();
      active.forEach(select => grouped.set(select.value,(grouped.get(select.value) || 0) + 1));
      const items = [...grouped].map(([id,quantity]) => ({ id, quantity }));
      this.busy = true; this.update(null); this.form.setAttribute('aria-busy','true');
      try {
        const response = await fetch(`${this.dataset.addUrl}.js`, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type':'application/json','Accept':'application/json' }, body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(destination);
      } catch (exception) {
        error.textContent = exception.message === 'Failed to fetch' ? this.dataset.error : exception.message;
        error.hidden = false; cartLink.hidden = false;
        this.busy = false; this.update(null); this.form.removeAttribute('aria-busy');
      }
    }
  });
}


